import React from 'react'
import StencilBox from '../stencils/StencilBox'

function BannerSixStencil() {
    return (
        <div>
            <section className="masthead -type-7 js-mouse-move-container">
                <div className="bg-white rounded-5">
                    <div className="container">
                        <div className="row justify-content-between align-items-center">

                            <div
                                className="col-12 col-xl-7 col-lg-6"
                                data-aos="fade-up"
                                data-aos-delay="500"
                            >
                                <div className="masthead__content">

                                    <h1 className="masthead__title text-white is-in-view">
                                        <StencilBox
                                            width="100%"
                                            height="100px"
                                            backgroundColor="#F5F5F5"
                                            border="none"
                                        />
                                    </h1>
                                    <p className="masthead__text text-16 text-white lh-2 pt-10 is-in-view">
                                        <StencilBox
                                            width="100%"
                                            height="50px"
                                            backgroundColor="#F5F5F5"
                                            border="none"
                                        />
                                    </p>

                                    <div>
                                        <div className="masthead-form bg-white rounded-5 mt-30 p-3">
                                            <form
                                                className="d-flex align-items-center justify-content-center flex-wrap gap-3"
                                            >
                                                <div className="w-25">
                                                    <StencilBox
                                                        width="100%"
                                                        height="50px"
                                                        backgroundColor="#F5F5F5"

                                                    />
                                                </div>


                                                <div className="w-25">
                                                    <StencilBox
                                                        width="100%"
                                                        height="50px"
                                                        backgroundColor="#F5F5F5"

                                                    />
                                                </div>

                                                <div className="w-25">
                                                    <StencilBox
                                                        width="100%"
                                                        height="50px"
                                                        backgroundColor="#F5F5F5"

                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-xl-5 col-lg-6"
                                data-aos="fade-up"
                                data-aos-delay="750"
                            >
                                <div className="masthead-image d-flex justify-content-center">
                                    <div className="masthead-image__img1">
                                        <StencilBox
                                            width="310px"
                                            className="banner-thumbnail-stencil-img"
                                            height="390px"
                                            backgroundColor="#F5F5F5"
                                            border="none"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default BannerSixStencil
